<template lang="pug">
    .row-teaser(v-if="display === 'list'" :class="{ hover: mouseover }")
        .image
            router-link(
                v-if="path"
                :to="path"
                @mouseover.native="hover"
                @mouseleave.native="blur"
            )
                figure(v-if="image")
                    img(v-if="showImage" v-lazy="image" :title="title")
                figure.date(v-else)
                    .center
                        .month {{ start.month }}
                        .day(:style="{ color }") {{ start.day }}
            component(
                v-else
                :is="tag"
                v-bind="properties"
                @mouseover.native="hover"
                @mouseleave.native="blur"
            )
                figure(v-if="image")
                    img(v-if="showImage" v-lazy="image" :title="title")
                figure.date(v-else)
                    .center
                        .month {{ start.month }}
                        .day(:style="{ color }") {{ start.day }}
        .text
            p.topic.is-uppercase.has-text-weight-bold(v-if="topic")
                | {{ topic }}
            h3.is-size-4(v-if="title")
                | {{ title }}
                .small {{ timespan }}
            .bait
                div(v-if="text" v-line-clamp:24="topic ? 4 : 5")
                    p.content(v-html="striptags(text)")
            .link
                router-link(v-if="path" :to="path") Weiterlesen ...
                component(v-else-if="href" :is="tag" v-bind="properties")
                    template(v-if="hyperlink.type === 'external'") {{ hyperlink.href }}
                    template(v-else-if="hyperlink.type === 'tel'") Anrufen...
                    template(v-else-if="hyperlink.type === 'mailto'") Email schreiben...
                slot(name="booking-link")

    .calendar-teaser(v-else-if="display === 'schedule'" ref="calendar-teaser" :class="{ 'invisible-content': ! clamps.calculated }")

        p.label(v-line-clamp:14.5="clamps.label") {{ title }}
        .bait
            div(v-if="text" v-line-clamp:12.5="clamps.bait")
                p.content(v-html="striptags(text)")
</template>

<script>

import _ from 'lodash'
import Color from 'color'
import striptags from 'striptags'
// import { mapGetters, mapMutations, mapActions } from 'vuex'

import { format, fromUnixTime, isSameDay } from 'date-fns'
import { de } from 'date-fns/locale'

export default {
    name: 'Teaser',
    props: {
        teaser: {
            type: Object,
            required: true,
        },
        showTopic: {
            type: Boolean,
            default: false,
        },
        display: {
            type: String,
            default: 'list',
            validator: val => ['list', 'schedule'].includes(val)
        }
    },
    data() {
        return {
            delay: 150,
            mouseover: false,
            showImage: true,
            clamps: {
                calculated: false,
                label: 0,
                bait: 0,
            }
        }
    },
    watch: {
        image() {
            // ugly workaround
            this.showImage = false
            this.$nextTick(() => {
                this.showImage = true
            })
        },
    },
    computed: {
        image() {
            let image

            if (this.teaserSection) {
                const content = this.teaserSection.contents.find(content => content.key === 'image')
                if (content && content.images.length) image = content.images[0]
            }

            if (! image && this.sections.length) {
                this.sections.forEach(section => {
                    if (image) return

                    const content = section.contents.find(content => content.key === 'image')
                    if (content && content.images.length) image = content.images[0]
                })
            }

            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1.1111111111'
            const parameters = {
                // ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h } = parameters

            let width, height
            let aspectRatio = 4 / 3

            width = 320
            height = width / aspectRatio

            if (w && h) {
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&w=${width}&h=${height}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
            }
        },
        hyperlink() {
            return _.get(this.teaser, 'hyperlink') || {}
        },
        path() {
            let route

            if (this.hyperlink.type === 'post') {
                // category page

                const page = _.get(this.hyperlink, 'page')
                const categoryKey = _.get(page, 'category.key')
                const key = _.get(page, 'key')

                switch (categoryKey) {
                    case 'news':
                        route = `/aktuelles/${key}`
                        break;

                    case 'headerNews':
                        route = `/news/${key}`
                        break;

                    case 'events':
                        route = `/events/${key}`
                        break;
                }
            } else if (this.hyperlink.type === 'internal') {
                // menu item

                const menuItem = _.get(this.hyperlink, 'menuItem')
                route = _.get(menuItem, 'path')
            }

            return route
        },
        href() {
            let href

            if (this.hyperlink.type !== 'internal' && _.get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href
                switch (this.hyperlink.type) {
                    case 'external':
                        if (! _.startsWith(link, 'https://') && ! _.startsWith(link, 'http://')) href = `https://${link}`
                        else href = link
                        break;

                    case 'mailto':
                        href = `mailto:${link}`
                        break;

                    case 'tel':
                        href = `tel:${link}`
                        break;
                }
            }

            return href
        },
        tag() {
            let tag = 'div'
            if (this.href) tag = 'a'
            return tag
        },
        target() {
            return _.get(this.hyperlink, 'target') || '_self'
        },
        properties() {
            let properties
            if (this.href) {
                properties = {
                    target: this.target,
                    href: this.href
                }
            } else {
                properties = {
                    class: 'no-link'
                }
            }
            return properties
        },
        topic() {
            if (this.showTopic) return _.get(this.teaser, 'event.category.name')
        },
        title() {
            return _.get(this.teaser, 'event.name')
        },
        color() {
            let hex = this.teaser.event.color || this.teaser.event.category.color

            if (hex) {
                let color = Color(hex)

                const lightness = color.lightness()
                if (lightness > 45) color = color.lightness(45)

                return color.rgb().string()
            }
        },
        start() {
            let start = fromUnixTime(this.teaser.start_at)
            return {
                month: format(start, 'MMM', { locale: de }),
                day: format(start, 'dd', { locale: de })
            }
        },
        timespan() {
            let start = fromUnixTime(this.teaser.start_at)
            let end = fromUnixTime(this.teaser.end_at)
            if (isSameDay(start, end)) {
                start = format(start, 'PPPP, HH:mm', { locale: de })
                end = format(end, 'HH:mm', { locale: de })
            } else {
                start = format(start, 'PPP, HH:mm', { locale: de })
                end = format(end, 'PPP, HH:mm', { locale: de })
            }
            return `${start} - ${end}`
        },
        text() {
            let text = this.teaser.comment || _.get(this.teaser, 'event.description')

            if (! text) {
                let content

                if (this.teaserSection) {
                    content = this.teaserSection.contents.find(content => content.key === 'teaser')
                }
                if (! (content && content.text) && this.postSection) {
                    content = this.postSection.contents.find(content => content.key === 'content')
                }

                if (content && content.text) text = content.text
            }

            return text
        },
        sections() {
            switch (this.hyperlink.type) {
                case 'post':
                    return _.get(this.hyperlink, 'page.sections') || []

                case 'internal':
                    return _.get(this.hyperlink, 'menuItem.page.sections') || []

                default:
                    return []
            }
        },
        teaserSection() {
            return this.sections.find(section => section.key === 'category-page-teaser')
        },
        postSection() {
            return this.sections.find(section => section.key === 'post')
        },
    },
    methods: {
        hover() {
            if (this.hyperlink) {
                this.$emit('focus', this.item)
                this.mouseover = true
            }
        },
        blur() {
            if (this.hyperlink) {
                setTimeout(() => {
                    this.$emit('blur', this.item)
                    this.mouseover = false
                }, this.delay);
            }
        },
        striptags(html) {
            html = html.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />')
            return striptags(html, ['a', 'i', 'u', 'b', 'em', 'strong', 'span', 'br'])
        }
    },
    mounted() {
        if (this.$refs['calendar-teaser']) {
            const calculateClamps = () => {
                this.clamps.calculated = false
                this.clamps.label = 0
                this.clamps.bait = 0

                if (! _.isElement(this.$refs['calendar-teaser'])) return

                const style = getComputedStyle(this.$refs['calendar-teaser'])
                let height = this.$refs['calendar-teaser'].clientHeight
                height -= parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)

                const reduce = () => {
                    const label = this.$refs['calendar-teaser'].querySelector('.label')
                    const labelStyle = getComputedStyle(label)
                    const labelLineHeight = parseFloat(labelStyle.lineHeight)
                    const labelMargin = parseFloat(labelStyle.marginTop) + parseFloat(labelStyle.marginBottom)
                    const labelHeight = parseFloat(label.clientHeight) + labelMargin

                    const bait = this.$refs['calendar-teaser'].querySelector('.bait')
                    const baitStyle = getComputedStyle(bait)
                    const baitLineHeight = parseFloat(baitStyle.lineHeight)
                    const baitMargin = parseFloat(baitStyle.marginTop) + parseFloat(baitStyle.marginBottom)
                    const baitHeight = parseFloat(bait.clientHeight) + baitMargin

                    if (labelHeight > height - 2 * baitLineHeight - labelMargin - baitMargin) {
                        // label is larger than the existing space
                        this.clamps.bait = 2
                        this.clamps.label = ((height - 2 * baitLineHeight - labelMargin - baitMargin) / labelLineHeight)
                        this.clamps.calculated = true
                    } else if (labelHeight + baitHeight > height - 10) {
                        // label fits completely but bait needs to be trimmed
                        this.clamps.bait = ((height - labelHeight) / baitLineHeight)
                        this.clamps.calculated = true
                    } else {
                        // no clamps needed
                        this.clamps.calculated = true
                    }
                    // console.log(height, parseFloat(labelStyle.lineHeight), parseFloat(baitStyle.lineHeight));
                }
                this.$nextTick(reduce)

                // console.log(getTextHeight(this.title, '11.2px "Roboto", Helvetica, Arial, sans-serif'));
            }

            // new ResizeObserver( _.debounce(calculateClamps, 100)).observe(this.$refs['calendar-teaser'])
            new ResizeObserver(calculateClamps).observe(this.$refs['calendar-teaser'])
            calculateClamps()
        }
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    .row-teaser
        text-align: initial
        h3
            line-height: 1.3
            color: $primary
            font-family: $font-sec
            font-weight: 600
            margin-bottom: 10px
            .small
                font-family: $font
                font-size: .7em
                color: $darkgray
                font-weight: 500
        p.topic
            font-size: .85rem
            margin-bottom: 10px
        .bait
            margin-bottom: 10px
            div
                word-break: normal !important
                br + br
                    display: none
        .link
            display: flex
            justify-content: space-between
        figure
            position: relative
            width: 100%
            padding-bottom: 75% // 9 / 16
            display: block
            background: #D8D8D8
            border-radius: 20px
            margin-bottom: 20px
            transition: transform .8s ease
            img
                border-radius: 20px
                position: absolute
                width: 100%
                max-height: 100%
                left: 0
                top: 0
                box-shadow: $box-shadow-2
                transition: box-shadow .8s ease
        figure.date
            background: lighten(#D8D8D8, 10%)
            display: flex
            .center
                position: absolute
                width: 100%
                height: 100%
                display: flex
                flex-direction: column
                justify-content: center
                align-items: center
                .month
                    font-weight: 500
                    font-size: 1.8rem
                    line-height: 1
                    letter-spacing: .2rem
                    text-transform: uppercase
                    opacity: .6
                .day
                    font-size: 4rem
                    font-weight: 300
                    line-height: 1
                    color: $primary
        &.hover
            a figure
                transform: scale(1.04)
                img
                    box-shadow: $box-shadow-3
    +tablet
        .row-teaser
            display: flex
            flex-direction: row
            .image
                flex-basis: 200px
                flex-grow: 0
                flex-shrink: 0
                figure
                    margin-bottom: 0
            .text
                margin-left: 20px
                flex-grow: 1
                display: flex
                flex-direction: column
                .bait
                    flex-grow: 1

    .calendar-teaser
        max-width: 100%
        &.invisible-content
            opacity: 0
            visibility: hidden
            overflow: hidden
        .label
            font-size: 0.7rem
            padding: 0
            margin: 0
            line-height: 1.3
            height: auto
            font-weight: 500
            word-break: normal !important
            margin-bottom: 2px
        .bait
            // opacity: .9
            font-size: .6rem
            div
                word-break: normal !important
</style>
